/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
export var CrownImageType;
(function (CrownImageType) {
    CrownImageType["UINT8"] = "uint8";
    CrownImageType["UINT16"] = "uint16";
    CrownImageType["RGB24"] = "RGB24";
})(CrownImageType || (CrownImageType = {}));
/**
 * Available channels of the PolarScan
 */
export var ChannelType;
(function (ChannelType) {
    ChannelType["LABEL"] = "LABEL";
    ChannelType["PROPERTIES"] = "PROPERTIES";
    ChannelType["PHI"] = "PHI";
    ChannelType["THETA"] = "THETA";
    ChannelType["DISTANCE"] = "DISTANCE";
    ChannelType["RSSI"] = "RSSI";
    ChannelType["ALL_CHANNELS"] = "ALL_CHANNELS";
    ChannelType["DEFAULT"] = "";
})(ChannelType || (ChannelType = {}));
/**
 * LINEAR defines a Smooth linear transition between color stops and DISCRETE color jumps at the color stops
 */
export var ColorMapType;
(function (ColorMapType) {
    ColorMapType["LINEAR"] = "LINEAR";
    ColorMapType["DISCRETE"] = "DISCRETE";
})(ColorMapType || (ColorMapType = {}));
//# sourceMappingURL=CrownDesc.js.map